import React, { FC } from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from 'react-router-dom';
import { AppStore } from '../../types/redux/AppStore';
import { App } from './';

type Props = {
    store: AppStore
};

/**
 * This component only exists so that out App proper can have hook access to the redux store.
 * It may be that in the future we could throw our <Router> wrapper in here as well.
 */
const AppStoreWrapper: FC<Props> = ({ store }) => {
    return (
        <Provider store={store}>
			<Router basename="/">
                <App />
            </Router>
        </Provider>
    );
};

export default AppStoreWrapper;